import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusMedium,
    overflow: 'hidden',
    border: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  tableHead: {
    backgroundColor: tokens.colorNeutralBackground3,
  },
  th: {
    textAlign: 'left' as const,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.4px',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  tr: {
    cursor: 'pointer',
    transitionProperty: 'background-color',
    transitionDuration: tokens.durationFaster,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  td: {
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    fontSize: tokens.fontSizeBase300,
    verticalAlign: 'middle' as const,
  },
  cvCell: {
    fontFamily: 'monospace',
    fontSize: tokens.fontSizeBase200,
    maxWidth: '180px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  queryCell: {
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  skillCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    whiteSpace: 'nowrap' as const,
  },
  evalCell: {
    fontWeight: tokens.fontWeightSemibold as unknown as number,
  },
  cvCellWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  copyBtn: {
    minWidth: 'auto',
    padding: '2px',
    flexShrink: 0,
  },
});
